<div
  #pagePreviewList
  class="userselect-none relative flex h-full flex-col gap-4 overflow-x-hidden rounded-r-lg bg-zinc-600 p-4 transition-all duration-300"
  [ngClass]="
    isPreviewListExpandedOrHovered()
      ? ['w-[150px]', 'overflow-y-auto']
      : ['w-0', 'overflow-y-hidden']
  ">
  @if (documentClassFilterEnabled()) {
    <div
      class="sticky top-0 z-10 transition-all duration-300"
      [ngClass]="isPreviewListExpandedOrHovered() ? 'opacity-100' : 'opacity-0'">
      <shared-dp-document-class-filter
        [availableDocumentClasses]="availableDocumentClasses()"
        [availableBehandlers]="availableBehandlers()"
        (appliedDocumentClassesChanged)="onAppliedDocumentClassesChanged($event)"
        (appliedBehandlersChanged)="onAppliedBehandlersChanged($event)"
        growDirection="left"></shared-dp-document-class-filter>
    </div>
  }
  @if (isSingleDocumentView() && singleOpenedDocument() !== undefined) {
    @for (page of singleOpenedDocument()!.pages; track $index) {
      <shared-dp-preview-page-thumbnail
        class="transition-all duration-300"
        [ngClass]="isPreviewListExpandedOrHovered() ? 'opacity-100' : 'opacity-0'"
        [page]="page"
        [selected]="$index === currentPageIndex()"
        [index]="$index"
        (click)="selectDocumentPage(page.id)" />
    }
  } @else {
    @for (document of documents(); track document.id) {
      <shared-dp-preview-document-thumbnail
        class="transition-all duration-300"
        [ngClass]="isPreviewListExpandedOrHovered() ? 'opacity-100' : 'opacity-0'"
        [selected]="document.id === selectedDocumentId()"
        [typeThumbnail]="document.pages[0]"
        [document]="document"
        [documentLabelTemplate]="documentLabelTemplate()"
        [documentThumbnailOverlayTemplate]="documentThumbnailOverlayTemplate()"
        (click)="scrollToFirstPageOfDocument($index)" />
    }
  }
</div>
